import { isZero } from '@sleepstation/utils'
import memoize from 'fast-memoize'
import { map } from 'ramda'
import React, { useContext, useLayoutEffect } from 'react'
import { useLoaderData } from 'react-router'
import UserContext from '../../../context/UserContext'
import PageNavContainer from '../../../state/PageNavContainer'
import UpgradePage from './UpgradePage'

// -----------------------------------------------------------------------------
// Const
// -----------------------------------------------------------------------------

const PAGE_ID = `upgrade`

// -----------------------------------------------------------------------------
// Utils
// -----------------------------------------------------------------------------

const getChartData = memoize((value) =>
  map(({ index, score }) => {
    const isHighlighted = isZero(index)
    return {
      score,
      week: index,
      isHighlighted,
    }
  }, value)
)

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const UpgradeModule = () => {
  const loaderData = useLoaderData()
  const [, setNav] = PageNavContainer.useContainer()
  const { currentEnrolment } = useContext(UserContext)

  useLayoutEffect(() => {
    setNav({
      pageId: PAGE_ID,
    })
  }, [setNav])

  const {
    projections: { weeklyAverageSleepEfficiencies },
  } = currentEnrolment

  const chartData = getChartData(weeklyAverageSleepEfficiencies)

  return (
    <UpgradePage
      pageContent={loaderData.page.content}
      projectedSleepEfficiencyData={chartData}
      currentEnrolment={currentEnrolment}
    />
  )
}

export default UpgradeModule
